import React from 'react';
import { HeroBlock, HeroBlockProps } from './blocks/HeroBlock';
import { AboutBlock, AboutBlockProps } from './blocks/AboutBlock';
import { ReviewsBlock, ReviewsBlockProps } from './blocks/ReviewsBlock';
import { Json } from '@/integrations/supabase/types';

export interface PageBlock {
  id: string;
  type: string;
  order_index: number;
  content_json: any; // We cast from Json to specific props type inside the renderer
}

interface BlockRendererProps {
  blocks: PageBlock[];
}

export const BlockRenderer: React.FC<BlockRendererProps> = ({ blocks }) => {
  if (!blocks || blocks.length === 0) {
    // Renderiza um HeroBlock padrão como empty state ao invés de uma mensagem de erro
    return (
      <div className="w-full flex flex-col">
        <HeroBlock />
      </div>
    );
  }

  // Sort blocks by order_index
  const sortedBlocks = [...blocks].sort((a, b) => a.order_index - b.order_index);

  return (
    <div className="w-full flex flex-col">
      {sortedBlocks.map((block) => {
        switch (block.type) {
          case 'hero':
            return <HeroBlock key={block.id} {...(block.content_json as HeroBlockProps)} />;
          case 'about':
            return <AboutBlock key={block.id} {...(block.content_json as AboutBlockProps)} />;
          case 'reviews':
            return <ReviewsBlock key={block.id} {...(block.content_json as ReviewsBlockProps)} />;
          default:
            console.warn(`Block type "${block.type}" is not supported yet.`);
            return null;
        }
      })}
    </div>
  );
};
